import React, { memo } from 'react';
import { ItemMaster } from '../../../../../../../../services/apiTypes';
import {
  TableCell,
  IconButton,
  Checkbox,
  Box,
  Typography,
} from '@mui/material';
import { Edit, Delete, DragHandle } from '@mui/icons-material';
import { manageItemStyle } from '../../../../../InspectionItemTable';
import { MANAGE_ITEM_MODE } from '../../../../../../../../_constants/manageConst';

type DisplayDepth2RowProps = {
  item: ItemMaster;
  mode: number;
  isAdmin: boolean;
  stickyPosition: number[];
  onClickEditIcon: (data: ItemMaster) => void;
  onClickDeleteIcon: (data: ItemMaster) => void;
};

const DisplayDepth2RowComponent: React.FC<DisplayDepth2RowProps> = ({
  item,
  mode,
  isAdmin,
  stickyPosition,
  onClickEditIcon,
  onClickDeleteIcon,
}) => {
  return (
    <React.Fragment>
      <TableCell
        sx={[
          manageItemStyle.iconCellCenter,
          manageItemStyle.leftSideSticky,
          { left: stickyPosition[4] },
        ]}
      >
        {mode === MANAGE_ITEM_MODE.SORT && (
          <IconButton size="small" sx={{ cursor: 'grab', touchAction: 'none' }}>
            <DragHandle fontSize="small" />
          </IconButton>
        )}
      </TableCell>
      <TableCell
        sx={[
          manageItemStyle.leftSideSticky,
          {
            left: stickyPosition[5],
            p: 0,
            whiteSpace: 'nowrap',
          },
        ]}
      >
        <Box sx={manageItemStyle.nameBox}>
          <Box sx={manageItemStyle.emptyBox} />
          <Typography sx={manageItemStyle.nameTypography}>
            {item.displayName}
          </Typography>
        </Box>
      </TableCell>
      {isAdmin && (
        <TableCell sx={manageItemStyle.iconCellCenter}>
          <Checkbox
            name="isOptionalAddition"
            disabled
            checked={item.isOptionalAddition}
            sx={{ py: '2px' }}
          />
        </TableCell>
      )}
      <TableCell />
      <TableCell sx={{ py: 0, textAlign: 'center' }}>{item.pCode}</TableCell>
      <TableCell sx={{ py: 0, textAlign: 'center' }}>{item.fCode}</TableCell>
      <TableCell sx={{ py: 0 }}>{item.rCodeList.join(', ')}</TableCell>
      <TableCell sx={{ py: 0 }}>
        {item.selectedAttribute1.map((attr) => attr.name).join(', ')}
      </TableCell>
      <TableCell sx={{ py: 0 }}>
        {item.selectedAttribute2.map((attr) => attr.name).join(', ')}
      </TableCell>
      <TableCell sx={{ py: 0 }}>
        {item.selectedAttribute3.map((attr) => attr.name).join(', ')}
      </TableCell>
      <TableCell sx={{ py: 0 }}>
        {item.selectedAttribute5.map((attr) => attr.name).join(', ')}
      </TableCell>
      <TableCell sx={{ py: 0 }}>
        {item.selectedAttribute6.map((attr) => attr.name).join(', ')}
      </TableCell>
      <TableCell sx={{ py: 0 }}>
        {item.selectedBrandName.map((attr) => attr.name).join(', ')}
      </TableCell>
      <TableCell sx={{ py: 0, textAlign: 'center' }}>
        {item.selectedConditions}
      </TableCell>
      <TableCell sx={{ py: 0 }}>{item.criteria.text}</TableCell>
      <TableCell sx={{ py: 0 }}>{item.criteria.max}</TableCell>
      <TableCell sx={{ py: 0 }}>{item.criteria.min}</TableCell>
      <TableCell sx={{ py: 0 }}>{item.memo}</TableCell>
      {mode === MANAGE_ITEM_MODE.VIEW ? (
        <React.Fragment>
          <TableCell />
          <TableCell
            sx={[manageItemStyle.icon2Sticky, manageItemStyle.iconCellCenter]}
          >
            {(isAdmin || item.isOptionalAddition) && (
              <IconButton
                size="small"
                sx={manageItemStyle.iconCellCenter}
                onClick={() => onClickEditIcon(item)}
                onPointerDown={(e) => e.stopPropagation()}
              >
                <Edit fontSize="small" />
              </IconButton>
            )}
          </TableCell>
          <TableCell
            sx={[manageItemStyle.icon3Sticky, manageItemStyle.iconCellCenter]}
          >
            {(isAdmin || item.isOptionalAddition) && (
              <IconButton
                size="small"
                sx={manageItemStyle.iconCellCenter}
                onClick={() => onClickDeleteIcon(item)}
                onPointerDown={(e) => e.stopPropagation()}
              >
                <Delete fontSize="small" color="error" />
              </IconButton>
            )}
          </TableCell>
        </React.Fragment>
      ) : (
        <TableCell colSpan={3} />
      )}
    </React.Fragment>
  );
};

export const DisplayDepth2Row = memo(DisplayDepth2RowComponent);
